export default "__VITE_ASSET__DD_j3QxY__"